import React, { useState, useEffect } from "react";
import {
  TrendingUp,
  TrendingDown,
  Factory,
  DollarSign,
  BarChart3,
  Calendar,
  Menu,
  Bell,
  PieChart,
} from "lucide-react";

import * as Icon from "react-bootstrap-icons";

import {
  LineChart,
  Line,
  BarChart,
  Bar,
  PieChart as RePieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import {BsecDashboard} from '../components';
import configData from "../config.json";
import axios from "axios";
import { Outlet, useNavigate } from "react-router-dom";

// const monthlyData = [
//   {
//     month: "Jan",
//     sales: 420,
//     prevSales: 380,
//     production: 350,
//     prevProduction: 300,
//     profit: 120,
//     prevProfit: 90,
//   },
//   {
//     month: "Feb",
//     sales: 480,
//     prevSales: 400,
//     production: 390,
//     prevProduction: 340,
//     profit: 150,
//     prevProfit: 100,
//   },
//   {
//     month: "Mar",
//     sales: 510,
//     prevSales: 430,
//     production: 420,
//     prevProduction: 360,
//     profit: 180,
//     prevProfit: 120,
//   },
//   {
//     month: "Apr",
//     sales: 620,
//     prevSales: 520,
//     production: 500,
//     prevProduction: 420,
//     profit: 240,
//     prevProfit: 170,
//   },
//   {
//     month: "May",
//     sales: 720,
//     prevSales: 610,
//     production: 620,
//     prevProduction: 500,
//     profit: 320,
//     prevProfit: 220,
//   },
//   {
//     month: "Jun",
//     sales: 840,
//     prevSales: 700,
//     production: 700,
//     prevProduction: 580,
//     profit: 380,
//     prevProfit: 260,
//   },
// ];

const pieData = [
  { name: "Sales", value: 45 },
  { name: "Production", value: 30 },
  { name: "Profit", value: 25 },
];

const COLORS = ["#0d6efd", "#198754", "#dc3545"];

const DashboardCard = ({
  title,
  current,
  previous,
  cumulative,
  PYcumulative,
  icon,
  color,
}) => {
  const growth = (((current - previous) / previous) * 100).toFixed(1);

  return (
    <div style={{ background: "#fff", borderRadius: "15px", padding: "20px", boxShadow: "0 4px 15px rgba(0,0,0,0.08)",}} >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
        <div>
          <div style={{ display: "flex", justifyContent: "space-between",}}>
            <div>
              <p style={{ color: "#6c757d", marginBottom: "10px" }}>{title}</p>
            </div>
            <div>
              <p style={{ color: "#6c757d", marginBottom: "10px", fontSize:"10px", textAlign:"right" }}>(Amount In Lac)</p>
            </div>
          </div>
          <div className="row">

          <h2 style={{ margin: 0 }}>{Number(current).toFixed(0)}Lac</h2>

          <p style={{ color: growth > 0 ? "green" : "red", marginTop: "10px", fontWeight: "bold", }}>
            {growth}% from previous year
          </p>
          </div>
        </div>

        <div style={{ background: color, color: "#fff", padding: "15px", borderRadius: "12px",}}>
          {icon}
        </div>
      </div>

      <hr />

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px",}}>
        <div>
          <small>Cumulative</small>
          <h5>{Number(cumulative).toFixed(0)}Lac</h5>
        </div>

        <div>
          <small>Previous Year Cumulative</small>
          <h5>{Number(PYcumulative).toFixed(0)}Lac</h5>
        </div>       
      </div>
    </div>
  );
};

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [misData,setMisData]=useState([]);
  const navigate = useNavigate();

  useEffect(() => {
        const getMisData = async () => {
          const response=await axios.get(configData.SERVER_URL+`/bsecmisDashboard/${localStorage.getItem('branchID')}`)
          setMisData(response.data);
        };
        getMisData();
  
  }, []);

  const totalSales = misData.reduce((a, b) => a + Number(b.salesValue), 0); 
  const totalPrevSales = misData.reduce((a, b) => a + Number(b.preSalesValue), 0);
  const totalCumSales = misData.reduce((a, b) => a + Number(b.cumSalesValue), 0);
  const totalPYCumSales = misData.reduce((a, b) => a + Number(b.cumPreSalesValue), 0);
  
  const totalProduction = misData.reduce((a, b) => a + Number(b.proValue), 0);
  const totalPrevProduction = misData.reduce((a, b) => a + Number(b.preProValue), 0);
  const totalCumProduction = misData.reduce((a, b) => a + Number(b.cumProValue), 0);
  const totalPYCumProduction = misData.reduce((a, b) => a + Number(b.cumPreProValue), 0);

  const totalProfit = misData.reduce((a, b) => a + Number(b.profitLoss), 0);
  const totalPrevProfit = misData.reduce((a, b) => a + Number(b.preProfitLoss), 0 );
  const totalCumProfit = misData.reduce((a, b) => a + Number(b.cumProfitLoss), 0);
  const totalPYCumProfit = misData.reduce((a, b) => a + Number(b.cumPreProfitLoss), 0);

  const modules = [
  
    {
      moduleName: "MIS",
      icon: <Icon.PeopleFill />,
      menus: [
        { name: "MIS Entry", icon: <Icon.DatabaseFillAdd />, path: "/mis" },
        { name: "Target Entry", icon: <Icon.Bullseye  /> },
        { name: "Sales,Production,Profit-Loss Analysis", icon: <Icon.BarChartLineFill  /> },
      ],
    },
  
    {
      moduleName: "SETTINGS",
      icon: <Icon.GearFill />,
      menus: [
        { name: "User Settings", icon: <Icon.GearFill /> },
        { name: "Permissions", icon: <Icon.GearFill /> },
      ],
    },
  ];
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [openModule, setOpenModule] = useState("ATTENDANCE");

  const toggleModule = (moduleName) => {
    setOpenModule(openModule === moduleName ? "" : moduleName);
  };

  return (
    <div style={{display: "flex", minHeight: "100vh", background: "#f4f6f9", fontFamily: "Arial", marginTop:100 }} >
      {/* Sidebar */}
      {/* <div className="col-lg-2 col-md-3 p-0"  style={{ minHeight: "100vh",  background: "#1e293b", color: "white", }} >
                
                <div className="p-3 text-center border-bottom" style={{ background: "#0f172a" }}>
                  <h4 className="fw-bold">Enterprise ERP</h4>
                  
                </div>
      
               
                <div className="p-2">
      
                  {modules.map((module, index) => (
                    <div key={index} className="mb-2">
      
                    
                      <div className="d-flex justify-content-between align-items-center p-2 rounded"
                        style={{ cursor: "pointer",
                          background:
                            openModule === module.moduleName
                              ? "#334155"
                              : "transparent",
                        }}
                        onClick={() => toggleModule(module.moduleName)}
                      >
                        <div className="d-flex align-items-center gap-2">
                          {module.icon}
                          <span>{module.moduleName}</span>
                        </div>
      
                        <div>
                          {openModule === module.moduleName ? (
                            <Icon.ChevronDown />
                          ) : (
                            <Icon.ChevronRight />
                          )}
                        </div>
                      </div>
      
                    
                      {openModule === module.moduleName && (
                        <div className="ms-3 mt-2">
      
                          {module.menus.map((menu, i) => (
                            <div
                              key={i}
                              className="p-2 mb-1 rounded d-flex align-items-center gap-2"
                              style={{
                                cursor: "pointer",
                                background:
                                  activeMenu === menu.name
                                    ? "#2563eb"
                                    : "transparent",
                              }}
                              onClick={() => {
                                setActiveMenu(menu.name); 
                                navigate(menu.path);}}
                            >
                              {menu.icon}
                              <span>{menu.name}</span>
                            </div>
                          ))}
      
                        </div>
                      )}
                    </div>
                  ))}
      
                </div>
      
      </div> */}

      {/* Main */}
      <div style={{ flex: 1 }}>

        <div style={{ padding: "25px" }}>
          {/* Dashboard Cards */}
          <div style={{  display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: "20px",}}>
            <DashboardCard
              title="Total Sales"
              current={totalSales}
              previous={totalPrevSales}
              cumulative={totalCumSales}
              PYcumulative={totalPYCumSales}
              color="#0d6efd"
              icon={<TrendingUp size={30} />}
            />

            <DashboardCard
              title="Production"
              current={totalProduction}
              previous={totalPrevProduction}
              cumulative={totalCumProduction}
              PYcumulative={totalPYCumProduction}
              color="#198754"
              icon={<Factory size={30} />}
            />

            <DashboardCard
              title="Profit"
              current={totalProfit}
              previous={totalPrevProfit}
              cumulative={totalCumProfit}
              PYcumulative={totalPYCumProfit}
              color="#dc3545"
              icon={<DollarSign size={30} />}
            />
          </div>

          {/* Charts */}
          {/* <div
            style={{
              marginTop: "30px",
              display: "grid",
              gridTemplateColumns: "2fr 1fr",
              gap: "20px",
            }}
          >

            <div
              style={{
                background: "#fff",
                borderRadius: "15px",
                padding: "20px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
              }}
            >
              <h3>Yearly Sales Comparison</h3>

              <ResponsiveContainer width="100%" height={350}>
                <LineChart data={monthlyData}>
                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="month" />

                  <YAxis />

                  <Tooltip />

                  <Legend />

                  <Line
                    type="monotone"
                    dataKey="sales"
                    stroke="#0d6efd"
                    strokeWidth={3}
                    name="Current Year"
                  />

                  <Line
                    type="monotone"
                    dataKey="prevSales"
                    stroke="#dc3545"
                    strokeWidth={3}
                    name="Previous Year"
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>

            <div
              style={{
                background: "#fff",
                borderRadius: "15px",
                padding: "20px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
              }}
            >
              <h3>Business Distribution</h3>

              <ResponsiveContainer width="100%" height={350}>
                <RePieChart>
                  <Pie
                    data={pieData}
                    cx="50%"
                    cy="50%"
                    outerRadius={100}
                    label
                    dataKey="value"
                  >
                    {pieData.map((entry, index) => (
                      <Cell
                        key={index}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>

                  <Tooltip />
                </RePieChart>
              </ResponsiveContainer>
            </div>
          </div> */}

          {/* Production & Profit */}
          {/* <div
            style={{
              marginTop: "30px",
              background: "#fff",
              borderRadius: "15px",
              padding: "20px",
              boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
            }}
          >
            <h3>Production & Profit Analysis</h3>

            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={monthlyData}>
                <CartesianGrid strokeDasharray="3 3" />

                <XAxis dataKey="month" />

                <YAxis />

                <Tooltip />

                <Legend />

                <Bar
                  dataKey="production"
                  fill="#198754"
                  name="Production"
                />

                <Bar
                  dataKey="profit"
                  fill="#dc3545"
                  name="Profit"
                />
              </BarChart>
            </ResponsiveContainer>
          </div> */}

          {/* Data Table */}
          {/* <div
            style={{
              marginTop: "30px",
              background: "#fff",
              borderRadius: "15px",
              padding: "20px",
              overflowX: "auto",
              boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
            }}
          >
            <h3>Monthly Cumulative Report</h3>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "15px",
              }}
            >
              <thead>
                <tr style={{ background: "#f1f5f9" }}>
                  <th style={thStyle}>Month</th>
                  <th style={thStyle}>Sales</th>
                  <th style={thStyle}>Prev Sales</th>
                  <th style={thStyle}>Production</th>
                  <th style={thStyle}>Profit</th>
                </tr>
              </thead>

              <tbody>
                {monthlyData.map((item, index) => (
                  <tr key={index}>
                    <td style={tdStyle}>{item.month}</td>
                    <td style={tdStyle}>{item.sales}M</td>
                    <td style={tdStyle}>{item.prevSales}M</td>
                    <td style={tdStyle}>{item.production}M</td>
                    <td style={tdStyle}>{item.profit}M</td>
                  </tr>
                ))}
              </tbody>

              <tfoot>
                <tr style={{ background: "#f8fafc", fontWeight: "bold" }}>
                  <td style={tdStyle}>Total</td>
                  <td style={tdStyle}>{totalSales}M</td>
                  <td style={tdStyle}>{totalPrevSales}M</td>
                  <td style={tdStyle}>{totalProduction}M</td>
                  <td style={tdStyle}>{totalProfit}M</td>
                </tr>
              </tfoot>
            </table>
          </div> */}

        </div>
        
      </div>
    </div>
  );
};

export default Dashboard;